import { getAdder, getUnitStart } from "../time";
import { format, endOfDay, endOfYear, isSameMonth, startOfDay, endOfMonth, addMonths, } from "date-fns";
import { isEventInDay, isMultiEvent } from "../events";
const addYears = getAdder("year");
class YearView {
    constructor() {
        this.getBounds = (date, config) => {
            const start = getUnitStart("year", date, config?.weekStartsOn);
            const end = endOfDay(endOfYear(start));
            return [start, end];
        };
        this.getNext = (date) => {
            return addYears(date, 1);
        };
        this.getPrev = (date) => {
            return addYears(date, -1);
        };
        this.getViewModel = (activeDate, bounds, config, displayedEvents, calendars) => {
            this._config = config;
            const [start, end] = bounds;
            const months = [];
            let current = start;
            this._events = displayedEvents;
            while (!isSameMonth(current, addMonths(end, 1))) {
                const events = displayedEvents.filter(event => isEventInDay(event, [current, endOfMonth(current)]));
                months.push({
                    current,
                    events,
                    markers: this.markers.bind(this),
                });
                current = addMonths(current, 1);
            }
            return {
                title: this.getTitle.bind(this),
                events: displayedEvents,
                getEventById: this.getEventById.bind(this),
                months,
                calendars,
                activeDate,
                addEvent: this.addEvent.bind(this),
                removeEvent: this.removeEvent.bind(this),
                getDayEvents: this.getDayEvents.bind(this),
            };
        };
    }
    getTitle(date, config) {
        const [start, end] = this.getBounds(date, this._config);
        const { dateTitle } = this._config;
        return dateTitle
            ? dateTitle(date, [start, end])
            : format(start, "y", { locale: config.locale });
    }
    markers(date) {
        const range = [startOfDay(date), endOfDay(date)];
        const events = this._events.filter(event => isEventInDay(event, range));
        if (!events.length)
            return;
        return "wx-event-calendar-month-marker";
    }
    addEvent(event) {
        this._events.push(event);
    }
    removeEvent(id) {
        this._events = this._events.filter(ev => ev.id !== id);
    }
    getDayEvents(day) {
        const events = this._events.filter((ev) => isEventInDay(ev, [startOfDay(day), endOfDay(day)]));
        const multievents = [];
        const dayEvents = [];
        events.forEach(ev => {
            if (isMultiEvent(ev)) {
                multievents.push(ev);
            }
            else {
                dayEvents.push(ev);
            }
        });
        return {
            multievents,
            dayEvents,
        };
    }
    getEventById(id) {
        return this._events.find(ev => ev.id === id);
    }
}
export default YearView;
//# sourceMappingURL=year.js.map